import { Grid, Typography } from '@mui/material'
import { memo } from 'react'
import { toLocaleStringIn } from '../../util/general'
import { green, red } from '../../assets/colors'

export type Props = {
    profit: number
}

const PnlView = ({
    profit
}: Props) => {

    return (
        <Grid item gap={1} id="target-pnl-container" sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', minWidth: '90px' }}>
            <Grid item xs={12} textAlign={'center'}>
                <Typography variant="caption" component="span" color={'text.secondary'} className="trade-panel-text">
                    <Typography sx={{ fontSize: '12px' }}>
                        TARGET P/L
                    </Typography>
                </Typography>
            </Grid>
            <Grid item xs={12} textAlign={'center'} display={'flex'}>
                <Typography variant="body2" component="span" sx={{ height: '24px', display: 'flex', alignItems: 'center', fontSize: '16px', color: profit > 0 ? green : profit < 0 ? red : 'inherit' }}>
                    {toLocaleStringIn(profit)}
                </Typography>
            </Grid>
        </Grid>
    )
}

export default memo(PnlView)